<template>
    <div
        v-if="valid"
        class="embed-responsive"
    >
        <iframe
            loading="lazy"
            sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation"
            class="embed-responsive-item"
            allowfullscreen
            :src="url"
        />
    </div>
    <div v-else>
        <p>Video not found.</p>
    </div>
</template>

<script>
import modalVideoToggle from '../modules/video-modal'
export default {
    props: {
        src: {
            type: String,
            default: '',
        },

        params: {
            type: Object,
            default () {
                return null
            },
        },

        modal: {
            type: Boolean,
            default: false,
        },
    },

    data () {
        return {

            valid: false,
            url: '',
            videos: [
                {
                    reg: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i,
                    url: 'https://www.youtube.com/embed/$5',
                    params: {
                        'picture-in-picture': 1,
                        accelerometer: 1,
                        gyroscope: 1,
                    },
                },
                {
                    reg: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
                    url: 'https://player.vimeo.com/video/$1',
                    params: {
                        title: 0,
                        byline: 0,
                        portrait: 0,
                    },
                },
            ],
        }
    },

    watch: {
        src (val) {
            this.parse()
        },
    },

    mounted () {
        this.parse()
        if (this.modal == true) {
            modalVideoToggle()
        }
    },

    methods: {

        parse () {
            if (this.src) {
                for (let i = 0; i < this.videos.length; i++) {
                    const v = this.videos[i]
                    var m = v.reg.exec(this.src)

                    if (m) {
                        var params = Object.assign({}, v.params, this.params)
                        var query = Object.keys(params).map(key => key + '=' + params[key]).join('&')
                        var and = v.url.indexOf('?') >= 0 ? '&' : '?'
                        this.url = this.src.replace(v.reg, v.url) + and + query
                        this.valid = true
                        return
                    }
                }
            }
            this.valid = false
        },

    },
}
</script>
